import "../../style.scss";
import styles from "../../MapPopupStyles.js";
import { withStyles } from "@material-ui/core/styles";
import {
  TableFooter,
  TableCell,
  TableRow,
  CircularProgress,
  Button,
} from "@material-ui/core";

const Footer = ({
  classes,
  onMarkAsFirstStop,
  onMarkAsLastStop,
  infoData,
  isFirstStopInProgress,
  isLastStopInProgress,
}) => {
  return (
    <TableFooter>
      <TableRow className={classes.tableRowRoot}>
        <TableCell className={classes.tableButtonCell}>
          <Button
            className={classes.popupButton}
            variant="outlined"
            color="inherit"
            size="small"
            onClick={onMarkAsFirstStop}
          >
            {isFirstStopInProgress ? (
              <CircularProgress size={16} color="primary" />
            ) : infoData.isFirstStop ? (
              "Unmark as First Stop"
            ) : (
              "Mark as First Stop"
            )}
          </Button>
        </TableCell>
        <TableCell
          className={`${classes.tableButtonCell} ${classes.tableButtonRight}`}
        >
          <Button
            className={classes.popupButton}
            variant="outlined"
            color="inherit"
            size="small"
            onClick={onMarkAsLastStop}
          >
            {isLastStopInProgress ? (
              <CircularProgress size={16} color="primary" />
            ) : infoData.stopType === "AP" ? (
              "Drop Anchor Point"
            ) : infoData.isLastStop ? (
              "Unmark as Last Stop"
            ) : (
              "Mark as Last Stop"
            )}
          </Button>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default withStyles(styles)(Footer);
